import { useContext, useEffect } from 'react';
import BPHeader from './BPHeader';
import BPFooter from './BPFooter';
import { BusinessPartnerContext } from './BusinessPartnerCard';
import SimpleTable from '../SimpleTable';

const BPParents = () => {
  const { localBPData, isEditing, handleParentsCheckboxChange } = useContext(BusinessPartnerContext);

  const parentsData = localBPData?.['Parents'] || [];

  const tableData = {
    headings: [
      {
        label: '',
        key: 'checkbox',
        size: 0.2,
      },
      {
        label: 'Parent',
        key: 'parent',
        size: 0.8,
        textAlign: 'left',
      },
    ],
    values: parentsData.map((parent) => ({
      checkbox: (
        <input
          type="checkbox"
          checked={parent.checked}
          onChange={(e) => handleParentsCheckboxChange(parent.ParentTraderId, e.target.checked)}
          disabled={!isEditing}
        />
      ),
      parent: parent.companyName,
    })),
  };

  return (
    <>
      <section className="bp-parents">
        <BPHeader />
        <div style={{ padding: '20px' }}>
          <SimpleTable data={tableData} isHeaderRow={true} headerBackground="#d3d3d3" cellBackground="#ffffff" />
        </div>
      </section>
      <BPFooter />
    </>
  );
};

export default BPParents;
